import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/service")({
  head: () => pageHead({ title: 'RV Service & Repair', description: 'Certified RV service and repair in Castle Hayne, NC. Schedule maintenance for your motorhome or trailer.', path: '/service' }),
  beforeLoad: () => {
    throw redirect({ href: "/rv-service" });
  },
});
